export var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["LEFT"] = "LEFT";
    TooltipPosition["RIGHT"] = "RIGHT";
    TooltipPosition["TOP"] = "TOP";
    TooltipPosition["BOTTOM"] = "BOTTOM";
})(TooltipPosition || (TooltipPosition = {}));
export var TooltipType;
(function (TooltipType) {
    TooltipType["SIMPLE"] = "SIMPLE";
})(TooltipType || (TooltipType = {}));
